import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../i18n';

const MarkerDetails = ({ styles, markerObject }) => (
    <div className={styles.container}>
        {/* address */}
        {markerObject?.streetName
          && (
              <div className={styles.infoRow}>
                  <div>
                      <div className={styles.label}>
                          {i18n.t('locationDetails.address')}
                      </div>
                      <div className={styles.details}>
                          <address>
                              {`${markerObject?.streetName} ${markerObject?.houseNumber}`}
                              <br />
                              {`${markerObject?.postCode} ${markerObject?.community}`}
                              <br />
                              {`${markerObject?.country}`}
                          </address>
                      </div>
                  </div>
              </div>
          )}

        {/* contact only phone number */}
        {markerObject?.phoneNumber && (
            <div className={styles.infoRow}>
                <div className={styles.label}>
                    {i18n.t('locationDetails.contact')}
                </div>
                <div className={styles.details}>
                    {i18n.t('locationDetails.phoneNumber', { number: markerObject?.phoneNumber })}
                </div>
            </div>
        )}

        {/* more details */}
        {markerObject?.moreDetails && (
            <div className={styles.infoRow}>
                <div className={styles.label}>
                    {i18n.t('locationDetails.moreDetails')}
                </div>

                <div className={styles.details} dangerouslySetInnerHTML={{ __html: markerObject.moreDetails }} />
            </div>
        )}

        {/* homepage */}
        {markerObject?.homepage
          && (
              <div className={styles.infoRow}>
                  <div>

                      <div className={styles.details}>
                          <a
                              rel="noreferrer"
                              href={markerObject?.homepage}
                              className={styles.cta}
                              target="_blank"
                          >
                              <span className={styles.text}>
                                  {i18n.t('locationDetails.homepageText', { location: markerObject.name })}
                              </span>
                          </a>
                      </div>
                  </div>
              </div>
          )}
    </div>
);

MarkerDetails.propTypes = {
    styles: PropTypes.objectOf(PropTypes.string),
    markerObject: PropTypes.shape({
        categoryId: PropTypes.string,
        name: PropTypes.string,
        streetName: PropTypes.string,
        houseNumber: PropTypes.string,
        postCode: PropTypes.string,
        community: PropTypes.string,
        country: PropTypes.string,
        homepage: PropTypes.string,
        phoneNumber: PropTypes.string,
        moreDetails: PropTypes.string,
    }),
};

export default MarkerDetails;
